export default function visible(el: HTMLElement, { value }: { value?: boolean }): void {
	if (value) {
		// eslint-disable-next-line no-param-reassign
		el.style.visibility = 'visible';
	} else {
		// eslint-disable-next-line no-param-reassign
		el.style.visibility = 'hidden';
	}
}
